import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative w-full min-h-[720px] md:min-h-[820px] flex items-end overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/d7d49463-cb3a-4e17-bed8-14db381c2d7e/3267d4b1-168c-4008-93b0-04f2eeeae251_compressed_opener_001.webp"
          alt="World Brand Conference Hong Kong"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/40 to-background-950/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 pb-16 md:pb-28 pt-32 md:pt-40">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 backdrop-blur border border-accent-400/40 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              <span className="text-xs md:text-sm text-accent-100 tracking-widest">{t("hero.badge")}</span>
            </div>
            <h1 className="font-heading font-bold text-background-50 text-4xl md:text-6xl lg:text-7xl leading-[1.15] mb-6">
              {t("hero.title.line1")} <br className="hidden md:block" />
              <span className="text-accent-300">{t("hero.title.line2")}</span>
            </h1>
            <p className="text-background-100/90 text-base md:text-lg leading-relaxed max-w-2xl mb-8">
              {t("hero.description")}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#news"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-primary-600 hover:bg-primary-500 text-background-50 rounded-md font-medium text-sm tracking-wider whitespace-nowrap cursor-pointer transition-colors"
              >
                {t("hero.cta.learn")}
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="#about"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-background-50/40 text-background-50 hover:bg-background-50/10 rounded-md font-medium text-sm tracking-wider whitespace-nowrap cursor-pointer transition-colors backdrop-blur"
              >
                {t("hero.cta.about")}
              </a>
            </div>
          </div>

          <div className="lg:col-span-4 lg:pl-8">
            <div className="border-l-2 border-accent-400 pl-6">
              <div className="text-accent-300 text-xs md:text-sm tracking-widest mb-3">{t("hero.declaration.label")}</div>
              <p className="text-background-100/90 text-sm md:text-base italic leading-relaxed mb-4">
                {t("hero.declaration.quote")}
              </p>
              <div className="text-background-50 text-sm font-medium">{t("hero.declaration.name")}</div>
              <div className="text-background-100/70 text-xs">{t("hero.declaration.title")}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-background-50/70 flex flex-col items-center gap-2 z-10">
        <span className="text-xs tracking-widest">{t("hero.scroll")}</span>
        <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center animate-bounce"></i>
      </div>
    </section>
  );
}